import React from 'react';
import PropTypes from 'prop-types';

const cssClass = 'player-awards-tracker-leaderboard-mobile-table';

export const MobileTableHead = ({ headerGroup, skipColumns, seasonPid }) => {
    const compAbbr = PULSE.app.common.match.getCompAbbr(seasonPid);

    const customCells = {
        player: (column) => (
            <div
                className={`${cssClass}__header-cell`}
                role="columnheader"
                key={column.id}
            >
                <div className="stats-table__header-cell-button">
                    {column.render('Header')}
                </div>
            </div>
        ),
        totalVotes: (column) => (
            <div
                className={`${cssClass}__header-cell`}
                role="columnheader"
                key={column.id}
            >
                <button
                    className="stats-table__header-cell-button"
                    disabled={true}
                >
                    {column.render('Header')}
                </button>
            </div>
        ),
        bettingOdds: (column) => (
            <div
                className={`${cssClass}__header-cell`}
                role="columnheader"
                key={column.id}
            >
                <button
                    className="stats-table__header-cell-button"
                    disabled={true}
                    title={`SportsBet ${
                        compAbbr === 'AFLW' ? 'Best & Fairest' : 'Brownlow'
                    } Win`}
                >
                    <img
                        className="stats-table__sportsbet-callout"
                        src={`/resources/${window.RESOURCES_VERSION}/i/elements/sportsbet-callout.svg`}
                        alt={`SportsBet ${
                            compAbbr === 'AFLW' ? 'Best & Fairest' : 'Brownlow'
                        } Win`}
                    />
                </button>
            </div>
        )
    };

    const headers = headerGroup.headers.filter((column) => {
        if (!skipColumns) {
            return true;
        }
        return !skipColumns.includes(column.id);
    });

    /* eslint-disable */
    return (
        // Fake thead Row
        <div
            {...headerGroup.getHeaderGroupProps()}
            className={`${cssClass}__header-row`}
        >
            {headers.map((column) => {
                const cellContent = column.render('Header');
                const { onClick, ...headerProps } = column.getHeaderProps(
                    column.getSortByToggleProps()
                );

                if (customCells && customCells[column.id]) {
                    return customCells[column.id](column);
                }
            })}
        </div>
    );
    /* eslint-enable */
};

MobileTableHead.propTypes = {
    headerGroup: PropTypes.object.isRequired,
    skipColumns: PropTypes.array,
    seasonPid: PropTypes.string
};
